// extracted by mini-css-extract-plugin
export var standaloneTable = "_h2-0";
export var withExtraHeader = "_h2-1";